import { DefaultTheme } from 'styled-components'
import { Wrapper } from './styles'

interface SectionProps {
    children: React.ReactNode
    id?: string
    hasNoSpacings?: boolean
    hasSmallerSpacingsX?: boolean
    hasSmallerSpacingsY?: boolean
    theme?: DefaultTheme
    isOverflowVisible?: boolean
}

const Section = ({
    id,
    children,
    hasNoSpacings,
    hasSmallerSpacingsX,
    hasSmallerSpacingsY,
    theme,
    isOverflowVisible,
}: SectionProps) => (
    <Wrapper
        isOverflowVisible={isOverflowVisible}
        theme={theme}
        id={id}
        hasNoSpacings={hasNoSpacings}
        hasSmallerSpacingsX={hasSmallerSpacingsX}
        hasSmallerSpacingsY={hasSmallerSpacingsY}
    >
        {children}
    </Wrapper>
)

export default Section
